import {
  EmailSubscriptionsServiceClientImpl,
  UpdateEmailSubscriptionsResponse,
} from '../../../grpc_client/grips/protos/email_subscriptions/v1/email_subscriptions_service';
import {
  useGripsClientContext,
  useGrpcClientChannel,
} from '../../../ui/sharedContexts/GrpcClientContext';
import {getGripsDevice} from '../../../utils/grpc/grpc-device';
import {
  AsyncOperationReturnType,
  useAsyncOperation,
} from '../../../utils/hooks/useAsyncOperation';
import useDropTypeFromPath from '../../../utils/hooks/useDropTypeFromPath';
import {useDropsSubscriptionsContext} from '../context/SubscriptionsProvider';
import {
  DROP_PATH_TO_TYPE_MAP,
  DROP_TYPE_SUBSCRIPTION_MAP,
} from '../utils/constants';
import {useUpdateAllStoredSubscriptions} from './useUpdateAllStoredSubscriptions';

export const useUpdateDropsEmailSubscriptions = (
  preferredEmail: string,
): AsyncOperationReturnType<
  UpdateEmailSubscriptionsResponse,
  Error,
  [string]
> => {
  const {childShopId, device} = useGripsClientContext();
  const channel = useGrpcClientChannel();
  const {modalData} = useDropsSubscriptionsContext();
  const dropType = DROP_PATH_TO_TYPE_MAP[useDropTypeFromPath()];

  const [updateDropsEmailSubscriptions, updateDropsEmailSubscriptionsState] =
    useAsyncOperation(
      async (email: string) => {
        const client = new EmailSubscriptionsServiceClientImpl(channel);

        const subscriptions = [
          {
            type: DROP_TYPE_SUBSCRIPTION_MAP[dropType],
            isSelected: modalData.allDropsSubscriptionStatus,
          },
        ];

        return await client.updateEmailSubscriptions({
          email,
          childShopId,
          subscriptions,
          device: getGripsDevice(device),
        });
      },
      [
        channel,
        childShopId,
        device,
        modalData.allDropsSubscriptionStatus,
        dropType,
      ],
    );

  useUpdateAllStoredSubscriptions({
    state: updateDropsEmailSubscriptionsState,
    preferredEmail,
  });

  return [updateDropsEmailSubscriptions, updateDropsEmailSubscriptionsState];
};
